module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.chapter) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    בטעינה...\n    "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_vm._v(_vm._s(_vm.$t("game-new.game-page.error")))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t("game-new.game-page.back")))]) : _vm._e(), _vm._v(" "), (_vm.chapter) ? _c('div', {
    staticClass: "game-page"
  }, [_c('GameHeader', {
    attrs: {
      "currentData": _vm.data,
      "word": _vm.currentWord,
      "trigger": _vm.trigger,
      "title": _vm.title,
      "progress": _vm.progress,
      "total": _vm.playedItems
    }
  }), _vm._v(" "), (_vm.isSummary) ? _c('GameSummary', {
    attrs: {
      "msg": _vm.msg,
      "playedItems": _vm.currItems,
      "currentData": _vm.data
    },
    on: {
      "restartGame": _vm.restartGame
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSummary) ? _c('div', {
    staticClass: "word-game-main"
  }, [(_vm.question) ? _c('div', {
    staticClass: "question"
  }, [(_vm.question.qWord.id) ? _c('AudioBtn', {
    attrs: {
      "urlId": _vm.question.qWord.id,
      "autoplay": _vm.autoPlay,
      "idx": _vm.idx
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.question.onlyAudio && _vm.question.qWord.Eng) ? _c('span', {
    staticClass: "q"
  }, [_vm._v("\n          " + _vm._s(_vm.question.qWord.Eng))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.question) ? _c('ul', {
    staticClass: "answers grid"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('li', {
      key: answer.objectID,
      class: {
        nope: _vm.choosenId && _vm.question.qWord.objectID !== answer.objectID,
        rightword: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        damnright: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        wrong: _vm.choosenId === answer.objectID &&
          _vm.question.qWord.objectID !== answer.objectID
      },
      on: {
        "click": function($event) {
          return _vm.checkAnswerA(answer, _vm.idx)
        }
      }
    }, [_vm._v("\n          " + _vm._s(answer.heb) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showNext) ? _c('button', {
    staticClass: "btn-next",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-page.next_q")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('button', {
    staticClass: "btnSum",
    on: {
      "click": _vm.showSummary
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-page.summery")) + "\n      ")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c53c7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game-new/game-page.vue
// module id = 406
// module chunks = 1 2